import { ValidationConfig } from './types'

export const VALIDATION_CONFIGS: ValidationConfig[] = [
  {
    type: 'phone' as const,
    title: 'validationsByFeature.yourPhoneNumber',
    iconName: 'phone',
    iconBgColor: ['#0C2CBD', '#5BC7F6'],
    isPending: (user) => !user?.phone_number,
    isDisabled: (user) => !!user?.phone_number,
    onPress: () => {
      // Navigation will be handled in the component using useNavigate
      if (typeof window !== 'undefined') {
        window.location.href = '/add-phone'
      }
    },
  },
  {
    type: 'email' as const,
    title: 'validationsByFeature.yourEmail',
    iconName: 'emailInline',
    iconBgColor: ['#9081FF', '#2C1FE1'],
    isPending: (user) => !user?.email_confirmed,
    isDisabled: (user) => !!user?.email_confirmed,
    onPress: () => {
      if (typeof window !== 'undefined') {
        window.location.href = '/check-your-email'
      }
    },
  },
  {
    type: 'kyc' as const,
    title: 'validationsByFeature.yourIdentity',
    iconName: 'identity',
    iconBgColor: ['#F067FF', '#752DE7'],
    isPending: (user) => !user?.hasIdentityVerified,
    isDisabled: (user, actions) => {
      const isEmailRequired = actions?.some(
        (action) => action.data_type === 'email' && action.required,
      )
      const isPhoneRequired = actions?.some(
        (action) => action.data_type === 'phone' && action.required,
      )

      //SHOULD DISABLE IF:
      // - USER HAS IDENTITY VERIFIED
      // - EMAIL IS REQUIRED AND NOT CONFIRMED
      // - PHONE IS REQUIRED AND NOT SET
      return (
        !!user?.hasIdentityVerified ||
        (isEmailRequired && !user?.email_confirmed) ||
        (isPhoneRequired && !user?.phone_number) ||
        false
      )
    },
    disabledMessage: (user, actions) => {
      const isEmailRequired = actions?.some(
        (action) => action.data_type === 'email' && action.required,
      )
      const isPhoneRequired = actions?.some(
        (action) => action.data_type === 'phone' && action.required,
      )

      //SHOULD SHOW MESSAGE IF:
      // - EMAIL IS REQUIRED AND NOT CONFIRMED
      // - PHONE IS REQUIRED AND NOT SET
      if (
        ((isEmailRequired && !user?.email_confirmed) ||
          (isPhoneRequired && !user?.phone_number)) &&
        !user?.hasIdentityVerified
      ) {
        return 'api:validationErrors.finishOthersFirst'
      }

      return undefined
    },
    onPress: () => {
      if (typeof window !== 'undefined') {
        window.location.href = '/check-your-identity'
      }
    },
  },
]
